"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementCaptureService = void 0;
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */
const truncate_1 = __importDefault(require("lodash/truncate"));
const Common_1 = require("./Common");
class ElementCaptureService {
    getTarget(target, selectors) {
        for (let i = 0; i < selectors.length; i += 1) {
            const captured = target.closest(selectors[i]);
            if (captured) {
                return {
                    target: captured,
                    selector: selectors[i],
                };
            }
        }
        return null;
    }
    getEntriesAndMetrics(element) {
        const attributes = [];
        const legacyAttributes = [];
        const metrics = [];
        const legacyMetrics = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const attr of element.attributes) {
            if (attr.name.startsWith(Common_1.EVENT_ATTR_PREFIX)) {
                continue;
            }
            if (element.matches("input, textarea") && attr.name === "value") {
                continue;
            }
            if (attr.name.startsWith(Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX)) {
                metrics.push([attr.name.slice(Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX.length), attr.value]);
                continue;
            }
            if (attr.name.startsWith(Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX_LEGACY)) {
                legacyMetrics.push([attr.name.slice(Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX_LEGACY.length), attr.value]);
                continue;
            }
            if (attr.name.startsWith(Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX)) {
                attributes.push([attr.name.slice(Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX.length), attr.value]);
                continue;
            }
            if (attr.name.startsWith(Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX_LEGACY)) {
                legacyAttributes.push([attr.name.slice(Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX_LEGACY.length), attr.value]);
                continue;
            }
            attributes.push([attr.name, attr.value]);
        }
        return {
            attributes: Object.fromEntries([...legacyAttributes, ...attributes]),
            metrics: Object.fromEntries([...legacyMetrics, ...metrics]),
        };
    }
    collectFacets(element) {
        const { attributes, metrics } = this.getEntriesAndMetrics(element);
        return {
            id: element.getAttribute(Common_1.HTML_ATTR_COMPONENT_ID) ||
                element.getAttribute(Common_1.HTML_ATTR_COMPONENT_ID_LEGACY) ||
                element.id,
            type: element.getAttribute(Common_1.HTML_ATTR_COMPONENT_TYPE) ||
                element.getAttribute(Common_1.HTML_ATTR_COMPONENT_TYPE_LEGACY) ||
                element.tagName,
            name: element.getAttribute(Common_1.HTML_ATTR_COMPONENT_NAME) ||
                element.getAttribute(Common_1.HTML_ATTR_COMPONENT_NAME_LEGACY) ||
                element.getAttribute("name") ||
                (element.matches("input[type=image], img") && (element.getAttribute("alt") || element.getAttribute("src"))) ||
                (element.matches("input[type=reset], input[type=submit]") && element.getAttribute("value")) ||
                (!element.matches("textarea") && (0, truncate_1.default)(element.textContent || "", { length: Common_1.MAX_TEXT_CONTENT_LENGTH })) ||
                "",
            attributes,
            metrics,
        };
    }
}
exports.ElementCaptureService = ElementCaptureService;
